import {
    CLEAR_VENDOR_CHANGE_PASSWORD,
    VENDOR_CHANGE_PASSWORD_REQUEST,
    VENDOR_CHANGE_PASSWORD_SUCCESS,
} from "./type";

const initialState = {
    changePassword: null,
    loading: false,
};

const VendorChangePasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case VENDOR_CHANGE_PASSWORD_REQUEST:
            return { ...state, changePassword: null, loading: true };

        case VENDOR_CHANGE_PASSWORD_SUCCESS:
            return { ...state, changePassword: action.payload, loading: false };

        case CLEAR_VENDOR_CHANGE_PASSWORD:
            return { ...state, changePassword: null, loading: false };

        default:
            return state;
    }
};

export default VendorChangePasswordReducer;
